"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'account.grades.features.advancedPrompts': 'Zaawansowane Prompty',
    'account.grades.features.promptAssist': 'Asystent Promptów',
    'account.grades.features.antiHallucination': 'Anti-Halucynacja',
    'account.grades.features.advancedReports': 'Zaawansowane Raporty',
    'account.grades.features.chatThreadSharing': 'Udostępnianie Wątków Czatu',
    'account.grades.features.customBranding': 'Własny Branding',
    'account.grades.features.widgets': 'Widżety',
    'account.grades.features.customAiModels': 'Własne Modele AI',
    'account.grades.features.voiceAgent': 'Agent Głosowy',
    'account.grades.features.writingStyles': 'Style Pisania',
    'account.grades.features.maxAvatars': 'Awatarów',
    'account.grades.features.maxUsers': 'Użytkowników',
    'account.grades.features.maxProjects': 'Projektów',
    'account.grades.features.maxKnowledge': 'Wpisów Wiedzy',
    'account.grades.free': 'Darmowy',
    'account.grades.free.description': 'Podstawowe funkcje na start',
    'account.grades.free.feature1': 'Ograniczone miesięczne użycie',
    'account.grades.free.feature2': 'Podstawowe modele AI',
    'account.grades.free.feature3': 'Wsparcie społecznościowe',
    'account.grades.basic': 'Podstawowy',
    'account.grades.basic.description': 'Rozszerzone funkcje dla zwykłych użytkowników',
    'account.grades.basic.feature1': 'Zwiększone miesięczne użycie',
    'account.grades.basic.feature2': 'Standardowe modele AI',
    'account.grades.basic.feature3': 'Wsparcie email',
    'account.grades.pro': 'Pro',
    'account.grades.pro.description': 'Zaawansowane funkcje dla profesjonalistów',
    'account.grades.pro.feature1': 'Wysokie miesięczne użycie',
    'account.grades.pro.feature2': 'Modele AI premium',
    'account.grades.pro.feature3': 'Priorytetowe wsparcie',
    'account.grades.ultra': 'Ultra',
    'account.grades.ultra.description': 'Maksymalne funkcje dla zaawansowanych użytkowników',
    'account.grades.ultra.feature1': 'Nieograniczone użycie',
    'account.grades.ultra.feature2': 'Wszystkie modele AI',
    'account.grades.ultra.feature3': 'Dedykowane wsparcie',
};
